import React, { useEffect, useState } from "react";
import Footer from "../../Components/Layout/Footer/Footer";
import HeaderSatalite from "../../Components/Layout/Header/HeaderSatalite";
import SataliteHeader from "../../Components/Layout/Header/SataliteHeader";
import storage from "../../services/storage";
import ProductCard from "../AllProducts/ProductCard";
import { useDispatch, useSelector } from "react-redux";
import { SpinnerDotted } from "spinners-react";
import { Helmet } from "react-helmet";
import { GetTicketsApi } from "../../store/api/ticketingPot";
export default function RaffleTicket() {
    const token = storage.get("xAuthToken");
    const dispatch = useDispatch();
    const gift = " giftcard";
    const [loading, setLoading] = useState(false);
    const { activePotData, ticketList } = useSelector((state) => state.TicketingPot);
    useEffect(() => {
        storage.remove("referrer");
        storage.remove("referralUserId");
        TicketsFetchData();
    }, [dispatch]);
    const TicketsFetchData = async () => {
        setLoading(true);
        dispatch(
            GetTicketsApi({
                onSuccess: (res) => {
                    setLoading(false);
                },
            })
        );
    };
    return (
        <div>
            <Helmet>
                <title>JKDIGITALS - Raffle Ticket</title>
                <meta
                    name="description"
                    content="Jkdigitals stands as a community committed to giving back. Every art purchase includes free benefits - our way of saying 'thank you'. These aren't mere add-ons; they're gateways to unexpected rewards, enriching your journey in art. JKDIGITALS is an artist collective focused on giving back to their online community through sweepstakes and giveaways.Art that Ignites Creativity. Digital Collectables made by creators the world over. With every JKDIGITALS purchase get free Lionsdengames&reg; Sweepstakes Coins Our partnership with Lionsdengames&reg; allows us to give issue free Coins that further supports our digital creators. Lionsdengames&reg; creators generate hundreds of new Art pieces a week tailored to our audience's preferences. Join the Lionsdengames&reg; Family Today!. By purchasing Art with JKDIGITALS, you're issued Coins on Lionsdengames&reg;. This supports our Artists and you! Play for free on Lionsdengames.net after purchase."
                />
            </Helmet>
            <div>
                <section className="satellite_blend">
                    <div className="satellite_inner">
                        <div className="satalite_header_wrap">
                            {token ? (
                                <HeaderSatalite />
                            ) : (
                                <div className="pt3">
                                    <SataliteHeader />
                                </div>
                            )}
                        </div>
                        <div className="satellite_blend_mobile satellite_blend_mobile_single_prod "></div>
                        <div className="top_light_wrapper"></div>
                        <div className="bottom_light_wrapper"></div>
                        <div className="theme-container theme-container-padd-100 theme-con-padd-btm-100">
                            <div className="cards_min_height_wrapper">
                                <div className="pageTittle_h1">
                                    <h1>Raffle Ticket</h1>
                                </div>
                                {!activePotData ? (
                                    <>
                                        <div className="pageTittle_h1">
                                            <h1>No Active Raffle Ticket</h1>
                                        </div>
                                    </>
                                ) : (
                                    <>   {loading && ticketList?.length === 0 ? (
                                        <div className="centerLogo-show">
                                            <SpinnerDotted style={{ height: "40", color: "#fff" }} />
                                        </div>
                                    ) : (
                                        <>
                                            <ProductCard
                                                products={ticketList}
                                                loading={loading}
                                                giftcard={gift}
                                                setLoading={setLoading}
                                            />
                                        </>
                                    )}</>
                                )}

                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        </div>
    );
}
